import React, { useEffect, useState } from 'react';

export function TableOfContents({ items, label = 'Inhalt', top = 'top-0' }) {
  const [active, setActive] = useState(items[0]?.id);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, { rootMargin: '-20% 0px -60% 0px' });
    items.forEach(it => { const el = document.getElementById(it.id); if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, [items]);

  return (
    <nav aria-label={label} data-testid="table-of-contents" className={`sticky ${top} z-30 border-y border-gray-200 bg-white/85 backdrop-blur-md`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex gap-2 overflow-x-auto py-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map(it => (
            <li key={it.id} className="flex-none">
              <a href={`#${it.id}`} data-testid={`toc-link-${it.id}`}
                className={`inline-flex whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${active === it.id ? 'bg-[#062417] text-white' : 'bg-gray-100 text-gray-700 hover:bg-emerald-50 hover:text-emerald-800'}`}>
                {it.label}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default TableOfContents;
